import { Alert } from '@mui/material';
import { FC, useState } from 'react';

type Props = {
	content: string;
};

export const TextBoxDanger: FC<Props> = ({ content }) => {
	const [shown, setShown] = useState<boolean>(true);

	const handleClose = () => {
		setShown(false);
	};

	if (!shown) return null;

	return (
		<Alert
			severity="error"
			onClose={handleClose}
			sx={{
				p: 2,
				'& .MuiAlert-message': { textAlign: 'center', width: 'inherit' }
			}}
		>
			{content}
		</Alert>
	);
};
